import * as React from "react";

export const SuccessIcon: React.FC<
  React.SVGProps<SVGElement> & { color?: string }
> = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M7 0A7 7 0 1 1 7 14 7 7 0 0 1 7 0m3.168 4a.82.82 0 0 0-.591.249L6.005 7.934 4.423 6.297a.82.82 0 0 0-.59-.248c-.458 0-.833.386-.833.857 0 .24.092.454.242.608l2.173 2.238c.15.154.357.248.59.248a.82.82 0 0 0 .591-.248l4.162-4.286a.87.87 0 0 0 .243-.609.85.85 0 0 0-.833-.857"
      clipRule="evenodd"
    ></path>
  </svg>
);
